module.exports = __webpack_public_path__ + "static/beholder_zombie-d7a8410d6d10128a82716583c2c99130.jpg";